import React from 'react';
import styled from 'styled-components';
import Media from '../shared/styled/Media';
import Pictogram from '../shared/Pictogram';
import { pictoComputer, pictoPrinter, pictoPackage } from '../../assets';

const List = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;

  @media ${Media.mobile} {
    flex-direction: column;
    margin: 2rem 0;
    padding: 0 1rem;
  }

  li {
    display: flex;
    align-items: center;
    align-self: center;
    font-size: 14px;
    flex: 1;
    height: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;

    @media ${Media.tablet} {
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }

    @media ${Media.mobile} {
      flex-direction: row;
      align-self: baseline;
      font-size: 16px;
      justify-content: flex-start;
      line-height: 1.5;
      margin-bottom: 1rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media ${Media.tablet} {
    .isvg {
      align-items: center;
      display: flex;
      margin-bottom: 0.5rem;
      min-height: 60px;
      justify-content: center;
      width: 100%;
    }
  }

  @media ${Media.mobile} {
    .isvg {
      display: block;
      width: 3.75rem;
      svg {
        height: 40px;
        width: 40px;
      }
    }
  }
`;

const HowToReturn = () => (
  <List>
    <li>
      <Pictogram path={pictoComputer} />
      <span className="mt-2 ml-2 mobile:ml-0">
        1. Select items you want to return
      </span>
    </li>
    <li>
      <Pictogram path={pictoPrinter} />
      <span className="mt-2 ml-2 mobile:ml-0">
        2. Download and print return label
      </span>
    </li>
    <li>
      <Pictogram path={pictoPackage} />
      <span className="mt-2 ml-2 mobile:ml-0">3. Pack and return items</span>
    </li>
  </List>
);

export default HowToReturn;
